import React, { useState, useEffect } from 'react'
import { Col, Modal, Row, Tabs } from 'antd'
import { withAuthenticationRequired, useAuth0 } from '@auth0/auth0-react'
import _ from 'lodash'
import ManagerMenu from '../components/manager/ManagerMenu'
import TournamentDisplay from '../components/manager/TournamentDisplay'
import { saveTournament } from '../shared/restClient'

import 'antd/dist/antd.css'
import './css/manager-home.css'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import Live from '../components/live/Live'

const { TabPane } = Tabs

const TournamentHome = () => {
  const [tournaments, setTournaments] = useState([])
  const [currentKey, setCurrentKey] = useState(false)
  const { getAccessTokenSilently, isAuthenticated } = useAuth0()

  useEffect(() => {
    async function fetchData () {
      const token = await getAccessTokenSilently({
        audience: 'https://saber-sport.com'
      })

      window.sessionStorage.setItem('token', token)
    }
    fetchData()
    // eslint-disable-next-line
  }, [getAccessTokenSilently, isAuthenticated])

  useEffect(() => {
    const save = async () => {
      const lastTournament = _.last(tournaments)

      if (!currentKey) setCurrentKey(lastTournament?.uuid)

      if (lastTournament?.uuid !== currentKey) {
        await saveTournament(lastTournament)
      } else {
        await saveTournament(lastTournament)
      }
    }
    if (tournaments.length > 0) {
      save()
    }

    // eslint-disable-next-line
  }, [tournaments])

  const handleChangeTab = (key) => {
    setCurrentKey(key)
  }

  const confirmRemove = (targetKey, action) => {
    Modal.confirm({
      title: 'Confirm',
      icon: <ExclamationCircleOutlined />,
      content: 'Close tab, are you sure?',
      okText: 'Yes',
      cancelText: 'No',
      onOk () {
        const newTournaments = tournaments.filter((tournament) => tournament.uuid !== targetKey)
        setTournaments(newTournaments)
        setCurrentKey(false)
      }
    })
  }

  const handleUpdate = (tournament) => {
    const newTournaments = JSON.parse(JSON.stringify(tournaments))

    const index = newTournaments.findIndex(t => t.uuid === tournament.uuid)
    newTournaments[index] = tournament

    setTournaments(newTournaments)
  }

  return (
    <div className='App'>
      <ManagerMenu addTournament={setTournaments} />
      <div className='card-container'>
        <Tabs type='editable-card' hideAdd onChange={handleChangeTab} activeKey={currentKey} onEdit={confirmRemove}>
          {tournaments.map((tournament) =>
            <TabPane tab={`${tournament.title} (${tournament?.rating ? tournament.rating : tournament?.possibleRating ? `Possible ${tournament.possibleRating}` : 'NR'} event)`} key={tournament.uuid} closable className='tab-pane'>
              {tournament?.isLive
                ? (
                  <Live id={tournament.uuid} onUpdate={handleUpdate} />
                  )
                : (
                  <TournamentDisplay key={tournament.uuid} tournament={tournament} onUpdate={handleUpdate} />
                  )}

            </TabPane>
          )}
        </Tabs>
      </div>
    </div>
  )
}

// export default TournamentHome
export default withAuthenticationRequired(TournamentHome, {
  onRedirecting: () => (
    <Row>
      <Col span={24} style={{ textAlign: 'center' }}>Loading</Col>
    </Row>
  )
})
